import { registerApplication, start, unloadApplication, triggerAppChange } from "single-spa";
import {
  constructApplications,
  constructRoutes,
  constructLayoutEngine,
} from "single-spa-layout";

const routes = constructRoutes(document.querySelector("#single-spa-layout2"));

const applications = constructApplications({
  routes,
  loadApp({ name }) {
    return System.import(name);
  },
});

const layoutEngine = constructLayoutEngine({ routes, applications });
applications.forEach(registerApplication);

System.import("@php/style-guide").then(() => {
  layoutEngine.activate();
  start();  
  loadCookieHub();
  //checkVersion('style-guide');
});

async function getCurrentVersion(app_name){
  const response = await fetch('http://sns24-mfe-dev.min-saude.pt/sns24/'+app_name+'/version.json');
  const result = await response.json();
  return result;
}

async function checkVersion(app_name){
  let localVersion = localStorage.getItem(app_name + '_version');
  let currentVersion = await getCurrentVersion(app_name);

  if(localVersion){
    if(currentVersion > localVersion){
      //reset
      unloadApplication('@php/' + app_name)
      triggerAppChange()
      localStorage.setItem(app_name + '_version', currentVersion.version);
    }
  }else{
    localStorage.setItem(app_name + '_version', currentVersion.version);
  }
}

function adjustCookieHubAccessibility() {
  
  const dialogElement = document.getElementById("ch2-dialog");
  const titleElement  = document.getElementById("ch2-dialog-title");

  if (titleElement ) {
    ["role", "aria-level"].forEach((attr) => {
      if(titleElement.getAttribute(attr) === "heading" || attr === "aria-level") {
        titleElement.removeAttribute(attr);
      }
    });
  }

  if(dialogElement && titleElement){
    dialogElement.setAttribute("aria-labelledby", titleElement.id);
  }
}


function loadCookieHub() {
  var cpm = {};
  window.cookiehub.load(cpm);
  adjustCookieHubAccessibility();
}

